export default __webpack_public_path__ + "static/media/it_IT.f8061c79.svg";